<template>
  <section class="material-half-bg">
    <div class="cover"></div>
  </section>
  <section class="login-content">
    <router-view />
  </section>


  <!-- The router-view here will render either LoginPage or RegisterPage -->
</template>

<script>
export default {
  name: 'AuthLayout',
};
</script>

<style></style>